import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config'

const ds = resolveConfig(tailwindConfig)

export default ds

export const theme = ds.theme;
